export const iconFontAwesomeHandsHand = (
	<i className="fa-solid fa-hand"></i>
);
